import React from "react";
import Header from "./header";

import "../styles/layout.css";
import * as styles from "./layout.module.css";
import Footer from "./footer/footer";

const Layout = ({
  children,
  onHideNav,
  onShowNav,
  showNav,
  siteTitle,
  footerData,
  headerData,
}) => {
  return (
    <>
      {headerData && headerData.length && headerData[0].node.headerSection ? (
        <Header
          siteTitle={siteTitle}
          onHideNav={onHideNav}
          onShowNav={onShowNav}
          showNav={showNav}
          headerNode={headerData[0].node}
        />
      ) : null}
      <div>{children}</div>
      {footerData && footerData.length > 0 ? (
        <Footer footerNode={footerData[0].node} />
      ) : null}
    </>
  );
};

export default Layout;
